<template>
  <g v-if="event">
    <path ref="projectileHead" :d="path.d" class="projectile" stroke="transparent" fill="transparent" />

    <g ref="projectileTails">
      <path
        v-for="i in particleParts"
        :key="i"
        :d="path.d"
        class="projectile"
        stroke="transparent"
        fill="transparent"
      />
    </g>
  </g>
</template>

<script>
import { adopt } from '@svgdotjs/svg.js';
// import { mapState } from 'vuex';

export default {
  name: 'Projectile',
  props: {
    event: Object
  },
  data: () => ({
    particleParts: 4,
    projectileHead: null,
    projectileTails: []
  }),
  computed: {
    // ...mapState({
    //   hudata: 'mapStore/huData'
    // }),
    projectilesToHun() {
      if (!this.event.projectiles) {
        // console.log(this.event);
      }
      return this.event?.projectiles?.projectilesToHun?.projectilePaths;
    },
    path() {
      return this.projectilesToHun[Math.floor(Math.random() * 5)];
    },
    len() {
      return this.path?.len;
    },
    projectileLen() {
      if (this.len === 0) return 0;
      const len = (this.len / 100) * 95;

      if (len < this.particleParts + 1) return this.particleParts + 1;
      return len;
    },
    particleLen() {
      if (this.particleParts === 0) return 0;

      return this.projectileLen / (this.particleParts + 1);
    },
    headLen() {
      return this.particleLen;
    },
    headDashArray() {
      if (this.len === 0 || this.projectileLen === 0) {
        return '';
      }
      return `${this.headLen} ${this.len}`;
    },
    particleDashArray() {
      const dashArray = [];
      for (let i = 0; i < this.particleParts; i++) {
        dashArray.push(`${this.particleLen} ${this.len + (1 + i) * this.particleLen}`);
      }

      return dashArray;
    }
  },
  methods: {
    hexToRGBA(hex, A = 1) {
      let c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + A + ')';
    },
    animate() {
      // random duration for animation start for a more organic
      // animation pattern
      const randDuration = Math.floor(Math.random() * (1500 - 800 + 1)) + 800;
      const randStartOffset = Math.floor(Math.random() * (1400 - 50 + 1)) + 50;

      // set up starting attributes
      this.projectileHead
        .attr({
          'stroke-width': 3,
          stroke: this.hexToRGBA(this.event.color),
          'stroke-dasharray': this.headDashArray,
          'stroke-dashoffset': this.headLen
        })
        // kick off animation
        .animate(randDuration, randStartOffset, 'now')
        .attr({ 'stroke-dashoffset': -this.len });

      const tailsLen = this.projectileTails.length;
      this.projectileTails.forEach((tail, i) => {
        tail
          .attr({
            'stroke-width': tailsLen / 2 > i ? 2 : 1,
            stroke: this.hexToRGBA(this.event.color, (100 - (i + 1) * 3) / 100),
            'stroke-dasharray': this.particleDashArray[i],
            'stroke-dashoffset': this.headLen + (1 + i) * this.particleLen
          })
          .animate(randDuration + (1 + i) * 10, randStartOffset, 'now')
          .attr({ 'stroke-dashoffset': -this.len })
          .after(
            function () {
              if (i + 1 === tailsLen) {
                this.$emit('projectile-animation-done', this.event);
              }
            }.bind(this)
          );
      });
    }
  },
  mounted() {
    this.projectileHead = adopt(this.$refs.projectileHead);
    this.projectileTails = Array.from(this.$refs.projectileTails?.childNodes).map((pathEl) => adopt(pathEl));

    this.$nextTick(() => {
      this.animate();
    });
  }
};
</script>

<style lang="scss" scoped>
.projectile {
  pointer-events: none;
}
</style>
